import styled from 'styled-components'

import { COLOURS } from 'resources'

export const ContainerWhite = styled.div`
  display: flex;
  flex: 1;
  background-color: ${COLOURS.neutralWhite};
`

export const Container = styled.div`
  background-color: ${COLOURS.neutralWhite};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 0 20px 0 10px;
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  margin-left: 10px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
`

export const CategoryTitle = styled.p`
  font-family: Druk, sans-serif;
  color: ${COLOURS.neutralBlack};
  font-size: 26px;
  line-height: 26px;
  margin: 0;
  text-transform: uppercase;
  text-decoration: underline;
`

export const HeaderBackButton = styled.i`
  font-size: 24px;
  color: ${COLOURS.neutralBlack};
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.7;
  }
`

export const DisabledRewardContainer = styled.div`
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(100%);
`
